import { Controller } from "@hotwired/stimulus"

// Tracks the hovered or focused swatch so Cmd/Ctrl+C copies its hex.
export default class extends Controller {
  connect() {
    this.onKey = (event) => {
      if (!(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== "c" || !this.activeSwatch) return
      if (window.getSelection()?.toString() || event.target.closest("input, textarea, [contenteditable]")) return
      event.preventDefault()
      this.activeSwatch.querySelector("button").click()
    }
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  get activeSwatch() { return this.hoveredSwatch || this.focusedSwatch }
  hover(event) { this.hoveredSwatch = event.currentTarget }
  unhover() { this.hoveredSwatch = null }
  focus(event) { this.focusedSwatch = event.currentTarget }
  blur() { this.focusedSwatch = null }
}
